<script>
import useSharedData from "@/use/SharedData";
import CvTechFilter from "@/views/Recruitment/CvTech/Components/CvTechFilter.vue";
import {ref, watch} from "vue";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    name: "StrCvTechImport",
    components: {SimpleCvTechFilter: CvTechFilter},
    props: {
        disabled: Boolean,
    },
    setup(props, {emit}) {
        const {loading, dialog} = useSharedData();
        const {$i18n, $router, $route} = useTools();
        const {transformFilterValues} = useSharedMethod();
        dialog.value = false;
        const filter = ref({allRecords: true});

        const cvTechs = ref([]);
        const selected = ref([]);


        const headers = [
            {
                text: $i18n.t('common.last_name'),
                sortable: false,
                align: "left",
                value: "lastName",
                width: "0%"
            },
            {
                text: $i18n.t('common.first_name'),
                sortable: false,
                align: "left",
                value: "firstName",
                width: "0%"
            },
            {
                text: $i18n.t('data_select.RECRUITMENT_CV_TECH_SPECIALITY'),
                sortable: false,
                align: "left",
                value: "specialityName",
                width: "0%"
            },
            {
                text: $i18n.t('common.country_state'),
                sortable: false,
                align: "left",
                value: "stateName",
                width: "0%"
            },
            {
                text: $i18n.t('common.phone'),
                sortable: false,
                align: "left",
                value: "phone",
                width: "0%"
            },
            {
                text: $i18n.t('common.address'),
                sortable: false,
                align: "left",
                value: "address",
                width: "0%"
            },
            {
                text: $i18n.t('common.email'),
                sortable: false,
                align: "left",
                value: "email",
                width: "0%"
            },
        ];

        function findAll() {
            loading.value = true;
            filter.value.rowsPerPage = 20;
            filter.value.page = 0;
            filter.value.sortBy = "updateDateTime";
            filter.value.descending = true;
            axios.get('/cvTechs', {params: transformFilterValues(filter.value)}).then(response => {
                cvTechs.value = response.data.elements;
            }).finally(() => {
                loading.value = false;
            })
        }

        function save() {
            loading.value = true;
            let ids = selected.value.map(e => e.id);
            axios.post(`/cvTechSourcings/uploadFromCvTech/${$route.params.id}`, ids).then(response => {
                emit('upload', response.data);
                dialog.value = false;
                selected.value = [];
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "recruitment_sourcings.add.cv_techs.view", params: {id: item.id}});
        }


        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        return {
            loading,
            dialog,
            filter,
            headers,
            cvTechs,
            selected,
            view,
            save,
        }
    },
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="1200"
            scrollable
        >
            <v-card>
                <w-toolbar color="orange" :title="$t('module.cv_tech')"/>
                <v-container fluid>
                    <SimpleCvTechFilter :filter="filter"></SimpleCvTechFilter>
                    <br/>
                    <w-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="cvTechs"
                        sort-by="updateDateTime"
                        show-select
                        disable-pagination
                        fixed-header
                        height="350"
                        @rowDbClick="view"
                    >
                        <template v-slot:[`item.lastName`]="{ item }">
                            <w-chip color="blue darken-2" :text="item.lastName"/>
                        </template>
                        <template v-slot:[`item.firstName`]="{ item }">
                            <w-chip color="blue darken-2" :text="item.firstName"/>
                        </template>
                        <template v-slot:[`item.occupationName`]="{ item }">
                            <w-chip color="orange" :text="item.occupationName"/>
                        </template>
                        <template v-slot:[`item.stateName`]="{ item }">
                            <w-chip outlined :text="item.stateName"/>
                        </template>
                        <template v-slot:[`item.address`]="{ item }">
                            <w-chip outlined :text="item.address"/>
                        </template>
                        <template v-slot:[`item.specialityName`]="{ item }">
                            <w-chip outlined :text="item.specialityName"/>
                        </template>
                        <template v-slot:[`item.email`]="{ item }">
                            <w-chip outlined :text="item.email"/>
                        </template>
                        <template v-slot:[`item.phone`]="{ item }">
                            <w-chip outlined :text="item.phone"/>
                        </template>
                    </w-data-table>
                </v-container>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                    <w-btn-add show :loading="loading" @press="save"/>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <w-btn
            color="orange"
            icon="mdi-database-import"
            :text="$t('module.cv_tech')"
            :disabled="disabled"
            @press="dialog = true"
        />
    </div>
</template>